"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekAverage = exports.getSleepLookup = exports.getRegistrationsForWeek = exports.missingRegistrationsLastWeek = exports.dayTimeNapsUnValidItems = exports.validateDayTimeNapInputs = exports.validateTimeLaterThanWithActualDate = exports.getTimeWithActualDate = exports.validateTimeBeforeThan = exports.validateTimeLaterThan = exports.getTimeWithCorrectDate = exports.sleepLoggingItemNames = exports.SleepLoggingType = void 0;
var objectUtils_1 = require("../../../youwell-common/objectUtils");
var arrayUtils_1 = require("../../../youwell-common/arrayUtils");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var SleepLoggingType;
(function (SleepLoggingType) {
    SleepLoggingType[SleepLoggingType["dayLogging"] = 0] = "dayLogging";
    SleepLoggingType[SleepLoggingType["nightLogging"] = 1] = "nightLogging";
})(SleepLoggingType = exports.SleepLoggingType || (exports.SleepLoggingType = {}));
exports.sleepLoggingItemNames = {
    sleepTime: 'sleepTime',
    wakeTime: 'wakeTime',
};
var getTimeWithCorrectDate = function (time, date, loggingType) {
    var timeString = (0, dateUtils_1.getTimePartForInput)(time);
    if (!timeString) {
        return timeString;
    }
    if (!date) {
        return timeString;
    }
    var isoDateString = (0, dateUtils_1.isoDate)(date);
    if (Number(timeString.substring(0, 2) >= 17)) { // Evening (day before) for hours after 17:00
        isoDateString = (0, dateUtils_1.isoDate)((0, dateUtils_1.addDays)(date, -1));
    }
    if (loggingType === SleepLoggingType.nightLogging && Number(timeString.substring(0, 2) >= 15)) { // Hours from 15:00-23:00 set to be the day before
        isoDateString = (0, dateUtils_1.isoDate)((0, dateUtils_1.addDays)(date, -1));
    }
    return "".concat(isoDateString, "T").concat(timeString);
};
exports.getTimeWithCorrectDate = getTimeWithCorrectDate;
var validateTimeLaterThan = function (valueToCompare, date, loggingType) { return function (value) {
    if (valueToCompare) {
        return new Date((0, exports.getTimeWithCorrectDate)(value, date, loggingType)) >= new Date((0, exports.getTimeWithCorrectDate)(valueToCompare, date, loggingType));
    }
    return true;
}; };
exports.validateTimeLaterThan = validateTimeLaterThan;
var validateTimeBeforeThan = function (valueToCompare, date, loggingType) { return function (value) {
    if (valueToCompare) {
        return new Date((0, exports.getTimeWithCorrectDate)(value, date, loggingType)) <= new Date((0, exports.getTimeWithCorrectDate)(valueToCompare, date, loggingType));
    }
    return true;
}; };
exports.validateTimeBeforeThan = validateTimeBeforeThan;
var getTimeWithActualDate = function (time, date) {
    var timeString = (0, dateUtils_1.getTimePartForInput)(time);
    if (!timeString) {
        return null;
    }
    if (!date) {
        return timeString;
    }
    return "".concat((0, dateUtils_1.isoDate)(date), "T").concat(timeString);
};
exports.getTimeWithActualDate = getTimeWithActualDate;
// eslint-disable-next-line arrow-body-style
var validateTimeLaterThanWithActualDate = function (valueToCompare, date, loggingType) { return function (value) {
    return new Date((0, exports.getTimeWithActualDate)(value, date)) >= new Date((0, exports.getTimeWithCorrectDate)(valueToCompare, date, loggingType));
}; };
exports.validateTimeLaterThanWithActualDate = validateTimeLaterThanWithActualDate;
var validateDayTimeNapInputs = function (i, date, daytimeNaps) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var validation = { sleep: true, wake: true };
    if (!daytimeNaps) {
        return validation;
    }
    var sleepTime = (_b = (_a = daytimeNaps[i]) === null || _a === void 0 ? void 0 : _a.sleepTime) !== null && _b !== void 0 ? _b : null;
    var nextSleepTime = (_d = (_c = daytimeNaps[i + 1]) === null || _c === void 0 ? void 0 : _c.sleepTime) !== null && _d !== void 0 ? _d : null;
    var wakeTime = (_f = (_e = daytimeNaps[i]) === null || _e === void 0 ? void 0 : _e.wakeTime) !== null && _f !== void 0 ? _f : null;
    var prevWakeTime = (_h = (_g = daytimeNaps[i - 1]) === null || _g === void 0 ? void 0 : _g.wakeTime) !== null && _h !== void 0 ? _h : null;
    if (sleepTime) {
        var isLaterThanPrevDaytimeNapWakeTime = prevWakeTime ? (0, exports.validateTimeLaterThan)(prevWakeTime, date, SleepLoggingType.dayLogging)(sleepTime) : true;
        var isLaterThanCurrWakeTime = wakeTime ? (0, exports.validateTimeLaterThan)(wakeTime, date, SleepLoggingType.dayLogging)(sleepTime) : false;
        validation.sleep = isLaterThanPrevDaytimeNapWakeTime && !isLaterThanCurrWakeTime;
    }
    if (wakeTime) {
        var isLaterThanNextDaytimeNapSleepTime = nextSleepTime ? (0, exports.validateTimeLaterThan)(nextSleepTime, date, SleepLoggingType.dayLogging)(wakeTime) : false;
        var isLaterThanCurrDaytimeNapSleepTime = sleepTime ? (0, exports.validateTimeLaterThan)(sleepTime, date, SleepLoggingType.dayLogging)(wakeTime) : true;
        validation.wake = isLaterThanCurrDaytimeNapSleepTime && !isLaterThanNextDaytimeNapSleepTime;
    }
    return validation;
};
exports.validateDayTimeNapInputs = validateDayTimeNapInputs;
var dayTimeNapsUnValidItems = function (date, daytimeNaps) {
    var _a;
    var validationList = daytimeNaps === null || daytimeNaps === void 0 ? void 0 : daytimeNaps.map(function (dayTimeNap, index) { return ({ index: index, validation: (0, exports.validateDayTimeNapInputs)(index, date, daytimeNaps) }); });
    return (_a = validationList === null || validationList === void 0 ? void 0 : validationList.filter(function (d) { return !d.validation.sleep || !d.validation.wake; })) !== null && _a !== void 0 ? _a : [];
};
exports.dayTimeNapsUnValidItems = dayTimeNapsUnValidItems;
var missingRegistrationsLastWeek = function (sleepLookup) {
    var currentDate = (0, dateUtils_1.addDays)(null, -6);
    var missingEntries = [];
    while (currentDate <= (0, dateUtils_1.tomorrow)()) {
        var d = (0, dateUtils_1.isoDate)(currentDate);
        if (!sleepLookup[d] || !(sleepLookup[d].skipped || sleepLookup[d].completed)) {
            missingEntries.push(d);
        }
        currentDate = (0, dateUtils_1.addDays)(currentDate, 1);
    }
    return (0, arrayUtils_1.reverse)(missingEntries);
};
exports.missingRegistrationsLastWeek = missingRegistrationsLastWeek;
var getRegistrationsForWeek = function (sleepLookup, week) {
    var currentDate = week.start;
    var entries = [];
    while (currentDate < week.end) {
        var d = (0, dateUtils_1.isoDateWithoutTimezone)(currentDate);
        if (sleepLookup[d]) {
            entries.push(sleepLookup[d]);
        }
        else {
            entries.push({
                isoDateString: d,
                completed: false,
                partial: false,
                skipped: false,
                evening: false,
                night: false,
            });
        }
        currentDate = (0, dateUtils_1.addDays)(currentDate, 1);
    }
    return entries;
};
exports.getRegistrationsForWeek = getRegistrationsForWeek;
var getSleepLookup = function (sleepEntries) { return sleepEntries.reduce(function (prev, curr) {
    var _a;
    var _b, _c, _d;
    return (__assign(__assign({}, prev), (_a = {}, _a[(0, dateUtils_1.isoDate)(curr.date)] = {
        isoDateString: (0, dateUtils_1.isoDate)(curr.date),
        entry: curr,
        completed: curr.totalBedMinutes && curr.totalSleepMinutes,
        partial: !(curr.daytimeActivityRating && (0, objectUtils_1.hasValue)((_b = curr.sleepProperties) === null || _b === void 0 ? void 0 : _b.hasDaytimeNaps) && curr.bedTime && curr.sleepAtemptTime && curr.sleepTime && (0, objectUtils_1.hasValue)((_c = curr.sleepProperties) === null || _c === void 0 ? void 0 : _c.numberOfNightWakeups) && curr.outOfBedTime && curr.wakeTime && curr.sleepRating),
        skipped: !!((_d = curr.sleepProperties) === null || _d === void 0 ? void 0 : _d.userSkippedRegistering),
        evening: curr.bedTime || curr.sleepAtemptTime || curr.sleepTime,
        night: curr.outOfBedTime || curr.wakeTime,
    }, _a)));
}, {}) || {}; };
exports.getSleepLookup = getSleepLookup;
var getWeekAverage = function (sleepEntries) { return sleepEntries.reduce(function (prev, curr) {
    var _a, _b, _c, _d, _e;
    if (curr.entry && curr.completed) {
        return {
            start: prev.start || curr.isoDateString,
            end: curr.isoDateString,
            count: prev.count + 1,
            totalSleepMinutes: prev.totalSleepMinutes + ((_a = curr.entry.totalSleepMinutes) !== null && _a !== void 0 ? _a : 0),
            totalBedMinutes: prev.totalBedMinutes + ((_b = curr.entry.totalBedMinutes) !== null && _b !== void 0 ? _b : 0),
            awakeBedMinutes: prev.awakeBedMinutes + ((_c = curr.entry.awakeBedMinutes) !== null && _c !== void 0 ? _c : 0),
            sleepQuality: prev.sleepQuality + ((_d = curr.entry.sleepQuality) !== null && _d !== void 0 ? _d : 0),
            sleepRating: prev.sleepRating + ((_e = curr.entry.sleepRating) !== null && _e !== void 0 ? _e : 0),
        };
    }
    return __assign(__assign({}, prev), { start: prev.start || curr.isoDateString, end: curr.isoDateString });
}, {
    count: 0,
    totalSleepMinutes: 0,
    totalBedMinutes: 0,
    awakeBedMinutes: 0,
    sleepQuality: 0,
    sleepRating: 0,
}); };
exports.getWeekAverage = getWeekAverage;
